<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { regionConfig } from '@/config/region'

const props = defineProps<{
  latitude: number
  longitude: number
}>()

const mapContainer = ref<HTMLElement | null>(null)
let mapInstance: L.Map | null = null

onMounted(() => {
  if (!mapContainer.value) return

  const { sw, ne } = regionConfig.mapBounds
  mapInstance = new L.Map(mapContainer.value, {
    center: [props.latitude, props.longitude],
    zoom: 15,
    maxBounds: new L.LatLngBounds([sw.lat, sw.lng], [ne.lat, ne.lng]),
    layers: [
      new L.TileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
        maxZoom: 20
      })
    ],
    // Read-only: a still picture of where the crash was recorded
    dragging: false,
    scrollWheelZoom: false,
    doubleClickZoom: false,
    boxZoom: false,
    keyboard: false,
    touchZoom: false,
    zoomControl: false
  })

  // Amber, like every other recorded crash: it is a record, not footage.
  new L.Marker([props.latitude, props.longitude], {
    icon: new L.DivIcon({
      html: `<i class="q-icon mdi mdi-alert-circle" style="font-size:32px;color:#f2c037;filter:drop-shadow(0 1px 3px rgba(0,0,0,0.45))"></i>`,
      iconSize: [32, 32],
      iconAnchor: [16, 16],
      className: ''
    })
  }).addTo(mapInstance)
})

onBeforeUnmount(() => {
  mapInstance?.remove()
  mapInstance = null
})
</script>

<template>
  <div ref="mapContainer" class="crash-static-map" data-testid="crash-map" />
</template>

<style lang="scss" scoped>
.crash-static-map {
  height: 240px;
  width: 100%;
}
</style>
